import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import VideoRule1 from "@/assets/custom-digital-human-rule/video_rule_4.webp";
import VideoRule2 from "@/assets/custom-digital-human-rule/video_rule_4@2x.webp";
import VideoRule3 from "@/assets/custom-digital-human-rule/video_rule_4@3x.webp";

export const VideoRule4Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[VideoRule3]}
      {...props}
    />
  );
};

VideoRule4Image.displayName = 'VideoRule4Image';
